import { phoneRegex } from 'noddi-util';
import { number, object, string } from 'yup';

export const addressValidationSchema = object({
  id: number().required('Address is required'),
  name: string().required('Address is required')
})
  .nullable()
  .required('Address is required');

export const phoneNumberValidationSchema = string()
  .matches(phoneRegex, 'Must be a valid phone number with country code (e.g. +123456789012) 8-15 digits')
  .required('Phone number is required');

export const emailValidationSchema = string().email('Invalid email format').required('Email is required');
